import "../sentryInstrumentReact";
import React from 'react';
import ReactDOM from 'react-dom/client';

import Checkout from './Checkout';
import { CartProvider } from './CartContext';

const checkoutDiv = document.getElementById('checkout');
if (checkoutDiv !== null) {
  const selectDiv = ReactDOM.createRoot(checkoutDiv);
  selectDiv.render(
    <>
      <CartProvider>
        <Checkout />
      </CartProvider>
    </>
  );  
}

